import { render, staticRenderFns } from "./DeleteStoreInfo.vue?vue&type=template&id=5fdfc47e"
import script from "./DeleteStoreInfo.vue?vue&type=script&lang=js"
export * from "./DeleteStoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports